import React, { lazy } from "react";
import { docLazyFn } from '@/router/untilFn'

// 沙盒-导航栏
import SandBox from '@/components/SandBox'


import MangerTimeSheet from '@/views/PayRoll/MangerTimeSheet/index'
import MangerAttendance from '@/views/PayRoll/MangerAttendance/index'
import EmployeesInformation from '@/views/PayRoll/EmployeesInformation/index'
import ManagerWorkTime from '@/views/PayRoll/ManagerWorkTime/index'
import ManagerWorkTimeDetail from '@/views/PayRoll/ManagerWorkTime/component/details'
const dashboardRouter = [
  {
    path: "/PayRoll",
    element: <SandBox />,
    children: [
      {
        path: "MangerTimeSheet",
        element: docLazyFn(<MangerTimeSheet />),
      },
      {
            path: "MangerAttendance",
            element: docLazyFn(<MangerAttendance />),
          },
      {
        path: "EmployeesInformation",
        element: docLazyFn(<EmployeesInformation />),
      },
      {
        path: "ManagerWorkTime",
        element: docLazyFn(<ManagerWorkTime />),
        
      }
    ],
  },
    {
       path: "/PayRoll/ManagerWorkTimeDetail",
       element: docLazyFn(<ManagerWorkTimeDetail />),
     },
];

export default dashboardRouter;
